<template>
  <div id="bm-team-player-detailed" >
    <!-- 未登录/注册 之前展示为空 start -->
    <van-cell-group>
      <div class="bm-cell" v-if="player.auditProgress==2">
        <van-cell :border="false" title="审核状态" :value="player.auditDesc"/>
        <div class="note-label" v-html="'备注原因：'+player.auditRemark"></div>
      </div>
      <van-cell v-else title="审核状态" :value="player.auditDesc"/>
      <van-cell v-if="player.serialNumber && player.auditProgress==1" title="注册编号">
        <template #value>
          {{player.serialNumber}}
        </template>
        <template #right-icon v-if="player.showPlayerCard">
          <van-button plain type="info" size="mini" round hairline @click="goPermitPage">查看参赛证</van-button>
        </template>
      </van-cell>
      <div class="bm-cell" v-if="infoSetting['isPhotoPass'].default">
        <van-cell title="头像" :border="false">
          <template #value>
            <div class="teamIcon">
              <div class="upload-profile-lod" v-show="profileLod" >
                <van-loading type="spinner" />
              </div>
              <van-uploader v-show="!profileLod" class="uploader" :after-read="onRead" :disabled="player.auditProgress === 1">
                <img v-if="imgObj.avatarImg" :src="imgObj.avatarImg" alt="">
                <img v-if="!imgObj.avatarImg" src="@/assets/images/team-logo-empty.png">
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="note-label" v-html="infoSetting['isPhotoPass'].instruction"></div>
      </div>
      <van-cell title="姓名" :value="player.trueName" is-link @click="setValues('trueName')" />
      <van-cell v-if="infoSetting['gender'].default" title="性别" :value="player.gender" is-link @click="setPicker('gender')" ></van-cell>
      <van-cell v-if="infoSetting['number'].default" :title-class="{'editable': player.auditProgress==1}" :value-class="{'editable': player.auditProgress==1}" title="球衣号码" :value="player.number" is-link @click="setValues('number')" />
      <van-cell v-if="infoSetting['bmBirthday'].default" title="出生日期" :value="player.bmBirthday" @click="setPicker('bmBirthday')" is-link/>
      <van-cell v-if="infoSetting['contactNumber'].default" :title-class="{'editable': player.auditProgress==1}" :value-class="{'editable': player.auditProgress==1}" title="手机号" :value="player.contactNumber" is-link @click="setValues('contactNumber')" />
      <van-cell v-if="infoSetting['school'].default" title="就读学校" :value="player.school" is-link @click="setValues('school')" />
      <van-cell v-if="infoSetting['guardianName'].default" title="监护人姓名" :value="player.guardianName" is-link @click="setValues('guardianName')" />
      <van-cell v-if="infoSetting['high'].default" title="身高(CM)" :value="player.high" is-link @click="setValues('high')" />
      <van-cell v-if="infoSetting['weight'].default" title="体重(KG)" :value="player.weight" is-link @click="setValues('weight')" />
      <van-cell v-if="infoSetting['bmEmail'].default" title="电子邮箱" :value="player.bmEmail" is-link @click="setValues('bmEmail')" />
      <van-cell v-if="infoSetting['clothesSize'].default" title="球衣尺码" :value="player.clothesSize" is-link @click="setValues('clothesSize')" />
      <van-cell v-if="infoSetting['position'].default" title="场上位置" :value="player.position" is-link @click="setPicker('position')" />
      <div class="bm-cell" v-if="infoSetting['isProfessionalPlayer'].default">
        <van-cell title="是否职业球员" :border="false" :value="player.isProfessionalPlayerDesc" is-link @click="setPicker('isProfessionalPlayerDesc')" ></van-cell>
        <div class="note-label" v-html="infoSetting['isProfessionalPlayer'].instruction"></div>
      </div>
      <van-cell v-if="infoSetting['IDCardNumber'].default" title="身份证号" :value="player.IDCardNo" is-link @click="setValues('IDCardNo')" />
      <div class="bm-cell" v-if="infoSetting['isIDCardPhotoPass'].default">
        <van-cell :border="false" title="身份证照片" :value="isUploadId" is-link @click="goUploadCard" />
        <div class="note-label" v-html="infoSetting['isIDCardPhotoPass'].instruction"></div>
      </div>
      <div class="bm-cell" v-if="infoSetting['qualificationFile'].default">
        <van-cell title="资格证明材料" :border="false">
          <template>
            <div class="teamIcon imgIcon">
              <van-uploader class="uploader" :after-read="onReadCert" :disabled="player.auditProgress===1">
                <img v-if="imgObj.certImg" :src="imgObj.certImg" alt="">
                <i v-else class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="note-label" v-html="infoSetting['qualificationFile'].instruction"></div>
      </div>
      <div class="bm-cell" v-if="infoSetting['insureFile'].default">
        <van-cell :title-class="{'editable': player.auditProgress==1}" title="运动意外险保单材料" :border="false">
          <template>
            <div class="teamIcon imgIcon">
              <van-uploader class="uploader" :after-read="onReadInsure">
                <img v-if="imgObj.insureImg" :src="imgObj.insureImg" alt="">
                <i v-else class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="note-label" v-html="infoSetting['insureFile'].instruction"></div>
      </div>
    </van-cell-group>
    <div style="width: 100%; height: 100px;" ></div>

    <!-- submit -->
    <div>
      <div class="foot" v-if="type !=='captain' && type !== 'match'" >
        <van-button type="primary" size="large" @click="updateBMPlayer" >确认</van-button>
        <!--      <div style="width: 100%; height: 20px;" ></div>-->
      </div>
      <div class="foot-create" v-if="type == 'captain'">
        <van-button type="primary" size="large" @click="createTeamPlayer" >确认</van-button>
      </div>
      <div class="foot" v-if="type ==='match'" >
        <van-button type="primary" size="large" @click="createTeamPlayer" >确认</van-button>
        <!--      <div style="width: 100%; height: 20px;" ></div>-->
      </div>
    </div>
    <!-- submit end -->

    <van-popup v-model="PopupShow" position="right" class="popup">
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" style="padding: 0 20px;">
        <van-col span="24" >
          <van-cell-group>
            <van-field v-model="newValue" placeholder="请输入..." />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24" style="padding: 0 30px;">
          <van-button round block type="primary" @click="confirmValue" style="margin-top: 15px;">确认</van-button>
          <van-button class="back-btn" round block @click="PopupShow=false" style="margin-top: 10px;">返回</van-button>
        </van-col>
      </van-row>
    </van-popup>

    <van-popup v-model="isShowPosition" position="bottom" >
      <van-picker
              show-toolbar
              @cancel="isShowPosition = false"
              @confirm="ConfirmPosition"
              :columns="columns"
              @change="positionTab"
      />
    </van-popup>

    <van-popup v-model="isShowGender" position="bottom" >
      <van-picker
              show-toolbar
              @cancel="isShowGender = false"
              @confirm="ConfirmGender"
              :columns="genders"
      />
    </van-popup>

    <van-popup v-model="isShowPro" position="bottom" >
      <van-picker
              show-toolbar
              @cancel="isShowPro = false"
              @confirm="ConfirmPro"
              :columns="proArray"
      />
    </van-popup>

    <van-popup v-model="isShowBmBirthday" position="bottom" >
      <van-datetime-picker
              @cancel="isShowBmBirthday = false"
              @confirm="setBmBirthday"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Moment from 'moment'
import { ImageFormat, varConfig } from '@/utils/'
import { getQiniuUploadToken } from '@/api/user'
import { getBMPlayerList, addSelftBMPlayer, getSelftBMPlayer, updateBMPlayer, bmMatchOrganizationAddBMPlayer } from '@/api/team'
import { getMatchInfo, getBMMatchSignUpRule } from '@/api/match'
import { Cell, CellGroup, Button, Popup, Picker, Toast, Icon, Loading } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Picker).use(Toast).use(Icon).use(Loading)

const citys = {
  '前锋': ['CF中锋', 'SS影子前锋', 'LWF左边锋', 'RWF右边锋'],
  '中锋': ['CAM前腰', 'CDM后腰', 'CM中前卫', 'LM左前卫', 'RM右前卫'],
  '后卫': ['CB中后卫', 'SW清道夫', 'LB左后卫', 'RB左后卫'],
  '门将': ['门将'],
  '其它': ['其它']
}

const auditState = ['待审核', '审核通过', '审核拒绝']

const setting = {
  bmTrueName: {
    value: 'bmTrueName',
    default: false,
    alias: 'trueName'
  },
  bmEmail: {
    value: 'bmEmail',
    default: false,
    alias: 'bmEmail'
  },
  isPhotoPass: {
    value: 'isPhotoPass',
    default: true,
    alias: 'avatar'
  },
  IDCardNumber: {
    value: 'IDCardNumber',
    default: false,
    alias: 'IDCardNo'
  },
  contactNumber: {
    value: 'contactNumber',
    default: false,
    alias: 'contactNumber'
  },
  isIDCardPhotoPass: { // 身份证正反面照 需要特殊处理
    value: 'isIDCardPhotoPass',
    default: false
  },
  weight: {
    value: 'weight',
    default: false,
    alias: 'weight'
  },
  high: {
    value: 'high',
    default: false,
    alias: 'high'
  },
  bmBirthday: {
    value: 'bmBirthday',
    default: false,
    alias: 'bmBirthday'
  },
  gender: {
    value: 'gender',
    default: false,
    alias: 'gender'
  },
  number: {
    value: 'number',
    default: false,
    alias: 'number'
  },
  position: {
    value: 'position',
    default: false,
    alias: 'position'
  },
  school: {
    value: 'school',
    default: false,
    alias: 'school'
  },
  guardianName: {
    value: 'guardianName',
    default: false,
    alias: 'guardianName'
  },
  clothesSize: {
    value: 'clothesSize',
    default: false,
    alias: 'clothesSize'
  },
  isProfessionalPlayer: {
    value: 'isProfessionalPlayer',
    default: false,
    alias: 'isProfessionalPlayer'
  },
  qualificationFile: {
    value: 'qualificationFile',
    default: false,
    alias: 'avatar'
  },
  insureFile: {
    value: 'insureFile',
    default: false,
    alias: 'insureFile'
  }
}
export default {
  name: 'PlayerDetailed',
  data () {
    return {
      query: '',
      PopupShow: false,
      teamName: '',
      teamId: null,
      matchId: null,
      player: {},
      playerId: null,
      key: null,
      columns: [
        {
          values: Object.keys(citys),
          className: 'column1'
        },
        {
          values: citys['前锋'],
          className: 'column2',
          defaultIndex: 0
        }
      ],
      isShowPosition: false,
      qiniuToken: '',
      user: false,
      userInfo: {},
      code: true,
      advertising: false,
      isShowUserForm: false,
      match: {},
      team: {},
      profileLod: false,
      setGender: false,
      genders: ['男', '女'],
      proArray: ['非职业球员', '职业球员'],
      isShowGender: false,
      isShowPro: false,
      isShowBmBirthday: false,
      minDate: new Date(1965, 0, 1),
      maxDate: new Date(),
      infoSetting: setting,
      imgObj: {
        certImg: '',
        insureImg: '',
        avatarImg: ''
      },
      newValue: '',
      birthday: null
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.squareImageView(this.player.avatar, 100)
    },
    isUploadId() {
      if (this.player.IDCardPhotoA && this.player.IDCardPhotoB) {
        return '已上传'
      } else if (this.player.IDCardPhotoA || this.player.IDCardPhotoB) {
        return '已上传'
      } else {
        return '未上传'
      }
    }
  },
  created() {
    this.query = this.$route.query
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    this.playerId = this.query.playerId
    this.type = this.query.type
    this.player = this.query
    if (this.player.bmBirthday) {
      this.player.bmBirthday = Moment(this.player.bmBirthday).format('YYYY-MM-DD')
    }
    // this.isSuccess = this.query.isSuccess === '1'
    // getPassport().then((response) => {
    //   if (response) {
    //     this.isShowUserForm = true
    //     if (!this.query.type) {
    //       // this.getSelftBMPlayer()
    //     }
    //     this.getBMMatchSignUpRule()
    //   } else {
    //     this.$router.push({
    //       name: 'Login',
    //       query: { redirect: this.$route.fullPath }
    //     })
    //   }
    // })
    this.getBMMatchSignUpRule()
    this.getBMPlayerList()
    this.getQiniuToken()
  },
  mounted() {
    this.player.isProfessionalPlayerDesc = this.player.isProfessionalPlayer == 1 ? '职业球员' : '非职业球员'
    this.imgObj.avatarImg = ImageFormat.squareImageView(this.player.avatar, 100)
  },
  methods: {
    setValues(key) {
      if (this.player.auditProgress === 1) { //
        if (!['number', 'contactNumber'].includes(key)) {
          Toast('审核通过后，该信息不允许再修改')
          return
        }
      }
      this.key = key
      this.newValue = this.player[key]
      this.PopupShow = true
    },
    setPicker(key) {
      if (this.player.auditProgress === 1) {
        Toast('审核通过后，该信息不允许再修改')
        return
      }
      if (key === 'gender') {
        this.isShowGender = true
      } else if (key === 'bmBirthday') {
        this.isShowBmBirthday = true
      } else if (key === 'position') {
        this.isShowPosition = true
      } else if (key === 'isProfessionalPlayerDesc') {
        this.isShowPro = true
      }
    },
    ConfirmPosition(value) {
      this.player.position = value.join('|')
      this.isShowPosition = false
    },
    positionTab(picker, values) {
      picker.setColumnValues(1, citys[values[0]])
    },
    signup() {
      let redirect = window.location.hash
      redirect = redirect.substring(1)
      this.$router.push({ name: 'Login', query: { redirect: encodeURIComponent(redirect) } })
    },
    errorInfo() {
      Toast('信息提交不全')
    },
    submitAction() {
      const params = {
        photo: this.player.photo,
        avatar: this.player.avatar,
        position: this.player.position,
        trueName: this.player.trueName,
        number: this.player.number,
        contactNumber: this.player.contactNumber,
        gender: this.player.gender,
        IDCardNumber: this.player.IDCardNo,
        IDCardPhotoA: this.player.IDCardPhotoA,
        IDCardPhotoB: this.player.IDCardPhotoB,
        teamId: this.teamId,
        matchId: this.matchId,
        high: this.player.high,
        weight: this.player.weight,
        bmEmail: this.player.bmEmail,
        school: this.player.school,
        guardianName: this.player.guardianName,
        isProfessionalPlayer: this.player.isProfessionalPlayer,
        qualificationFile: this.player.qualificationFile,
        insureFile: this.player.insureFile,
        clothesSize: this.player.clothesSize
      }
      if (this.player.bmBirthday) {
        params.bmBirthday = Moment(this.player.bmBirthday).format('YYYY-MM-DDTHH:mm:ss+0800')
      }
      for (let item in this.infoSetting) {
        let name = this.infoSetting[item].alias
        if (this.infoSetting[item].default && this.infoSetting[item].value === 'isIDCardPhotoPass') {
          if (!this.player.IDCardPhotoA && !this.player.IDCardPhotoB) {
            this.errorInfo()
            return
          }
        } else if (item != 'insureFile' && (this.infoSetting[item].default && !this.player[name])) {
          this.errorInfo()
          return
        }
      }
      addSelftBMPlayer(params).then((res) => {
        const data = res.data
        if (data) {
          // Toast('更新成功')
          this.$router.replace({ name: 'NamePlayer',
            query: {
              teamId: this.teamId,
              matchId: this.matchId,
              isSuccess: '1'
            }
          })
          window.location.reload()
        }
      })
    },
    goUploadCard() {
      this.$router.push({ name: 'UploadFile',
        query: { playerId: this.player.id,
          cardA: this.player.IDCardPhotoA,
          cardB: this.player.IDCardPhotoB,
          trueName: this.player.trueName,
          number: this.player.number,
          photo: this.player.photo,
          avatar: this.player.avatar,
          type: this.type,
          position: this.player.position,
          contactNumber: this.player.contactNumber,
          IDCardNumber: this.player.IDCardNo,
          teamId: this.teamId,
          matchId: this.matchId,
          gender: this.player.gender,
          high: this.player.high,
          weight: this.player.weight,
          bmEmail: this.player.bmEmail,
          bmBirthday: this.player.bmBirthday ? Moment(this.player.bmBirthday).format() : '',
          isProfessionalPlayer: this.player.isProfessionalPlayer,
          guardianName: this.player.guardianName,
          school: this.player.school,
          auditProgress: this.player.auditProgress,
          auditRemark: this.player.auditRemark,
          qualificationFile: this.player.qualificationFile,
          insureFile: this.player.insureFile
        }
      })
    },
    onRead(file) {
      this.profileLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.avatar = res.hash
          this.profileLod = false
          this.imgObj.avatarImg = ImageFormat.squareImageView(res.hash, 100)
        }
      })
    },
    onReadCert(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.qualificationFile = res.hash
          this.imgObj.certImg = ImageFormat.squareImageView(res.hash, 100)
        }
      })
    },
    onReadInsure(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.insureFile = res.hash
          this.imgObj.insureImg = ImageFormat.squareImageView(res.hash, 100)
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    },
    getMatchInfo: function() {
      getMatchInfo(this.matchId).then(response => {
        const data = response.data
        this.match = data.match
      })
    },
    getSelftBMPlayer() {
      let params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      this.popupLoading.loading()
      getSelftBMPlayer(params).then(response => {
        this.popupLoading.clear()
        const data = response.data
        this.match = data.match
        this.team = data.team
        if (data.player.userId) {
          const player = data.player
          this.imgObj.certImg = ImageFormat.squareImageView(player.qualificationFile, 100)
          this.imgObj.insureImg = ImageFormat.squareImageView(player.insureFile, 100)
          player.isProfessionalPlayerDesc = player.isProfessionalPlayer === 1 ? '职业球员' : '非职业球员'
          player.isProfessionalPlayer = player.isProfessionalPlayer && player.isProfessionalPlayer.toString()
          player.contactNumber = player.mobile
          player.auditDesc = auditState[player.auditProgress]
          this.player = player
          if (this.player.bmBirthday) {
            this.player.bmBirthday = Moment(this.player.bmBirthday).format('YYYY-MM-DD')
          }
        } else {
          this.player = {
            playerId: this.query.playerId,
            IDCardPhotoA: this.query.cardA,
            IDCardPhotoB: this.query.cardB,
            trueName: this.query.trueName,
            number: this.query.number,
            photo: this.query.photo,
            avatar: this.query.avatar,
            position: this.query.position,
            contactNumber: this.query.contactNumber,
            IDCardNumber: this.query.IDCardNumber,
            isProfessionalPlayer: this.query.isProfessionalPlayer || '0',
            school: this.query.school,
            guardianName: this.query.guardianName,
            auditProgress: this.query.auditProgress
          }
          this.player.isProfessionalPlayerDesc = this.player.isProfessionalPlayer == 1 ? '职业球员' : '非职业球员'
          this.player.auditDesc = auditState[this.player.auditProgress]
        }
      })
    },
    ConfirmGender(value) {
      this.player.gender = value
      this.isShowGender = false
    },
    ConfirmPro(value) {
      this.player.isProfessionalPlayer = (value === '职业球员') ? '1' : '0'
      this.player.isProfessionalPlayerDesc = value
      this.isShowPro = false
    },
    setBmBirthday(value) {
      this.player.bmBirthday = Moment(value).format('YYYY-MM-DD')
      this.isShowBmBirthday = false
    },
    getBMMatchSignUpRule() {
      getBMMatchSignUpRule(this.matchId).then(response => {
        if (response) {
          this.popupLoading.clear()
          const signUpRuleV2 = response.data.signUpRuleV2
          signUpRuleV2.forEach(reg => {
            const ret = setting[reg.field]
            if (ret) {
              ret.default = true
              ret.instruction = reg.instruction
              this.infoSetting[reg.field] = ret
            }
          })
        }
      })
    },
    confirmValue() {
      this.player[this.key] = this.newValue
      this.PopupShow = false
    },

    createTeamPlayer() {
      // const params = {
      //   teamId: this.teamId,
      //   matchId: this.matchId,
      //   photo: this.player.photo,
      //   position: this.player.position,
      //   trueName: this.player.trueName,
      //   number: this.player.number,
      //   mobile: this.player.mobile,
      //   gender: this.player.gender,
      //   bmBirthday: '',
      //   IDCardNumber: this.player.IDCardNumber,
      //   IDCardPhotoA: this.player.IDCardPhotoA,
      //   IDCardPhotoB: this.player.IDCardPhotoB,
      //   high: this.player.high,
      //   weight: this.player.weight,
      //   bmEmail: this.player.bmEmail
      // }
      const params = {
        photo: this.player.photo,
        avatar: this.player.avatar,
        position: this.player.position,
        trueName: this.player.trueName,
        number: this.player.number,
        contactNumber: this.player.contactNumber,
        gender: this.player.gender,
        IDCardNumber: this.player.IDCardNo,
        IDCardPhotoA: this.player.IDCardPhotoA,
        IDCardPhotoB: this.player.IDCardPhotoB,
        teamId: this.teamId,
        matchId: this.matchId,
        high: this.player.high,
        weight: this.player.weight,
        bmEmail: this.player.bmEmail,
        school: this.player.school,
        guardianName: this.player.guardianName,
        isProfessionalPlayer: this.player.isProfessionalPlayer,
        qualificationFile: this.player.qualificationFile,
        insureFile: this.player.insureFile,
        clothesSize: this.player.clothesSize
      }

      if (this.player.bmBirthday) {
        params.bmBirthday = Moment(this.player.bmBirthday).format()
      }
      bmMatchOrganizationAddBMPlayer(params).then((res) => {
        const data = res.data
        if (data) {
          Toast('添加球员成功')
          if (this.type === 'match') {
            this.$router.go(-1)
          } else {
            this.$router.go(-2)
          }
        }
      })
    },
    updateBMPlayer() {
      // const params = {
      //   playerId: this.player.id,
      //   photo: this.player.photo,
      //   position: this.player.position,
      //   trueName: this.player.trueName,
      //   number: this.player.number,
      //   mobile: this.player.mobile,
      //   gender: this.player.gender,
      //   bmBirthday: '',
      //   IDCardNumber: this.player.IDCardNumber,
      //   IDCardPhotoA: this.player.IDCardPhotoA,
      //   IDCardPhotoB: this.player.IDCardPhotoB,
      //   high: this.player.high,
      //   weight: this.player.weight,
      //   bmEmail: this.player.bmEmail
      // }
      const params = {
        playerId: this.player.id,
        photo: this.player.photo,
        avatar: this.player.avatar,
        position: this.player.position,
        trueName: this.player.trueName,
        number: this.player.number,
        contactNumber: this.player.contactNumber,
        gender: this.player.gender,
        IDCardNumber: this.player.IDCardNo,
        IDCardPhotoA: this.player.IDCardPhotoA,
        IDCardPhotoB: this.player.IDCardPhotoB,
        teamId: this.teamId,
        matchId: this.matchId,
        high: this.player.high,
        weight: this.player.weight,
        bmEmail: this.player.bmEmail,
        school: this.player.school,
        guardianName: this.player.guardianName,
        isProfessionalPlayer: this.player.isProfessionalPlayer,
        qualificationFile: this.player.qualificationFile,
        insureFile: this.player.insureFile,
        clothesSize: this.player.clothesSize
      }

      if (this.player.bmBirthday) {
        params.bmBirthday = Moment(this.player.bmBirthday).format()
      }
      updateBMPlayer(params).then((res) => {
        const data = res.data
        if (data) {
          Toast('更新成功')
          this.$router.go(-1)
        }
      })
    },
    getBMPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId,
        gameId: this.query.playerId
      }
      getBMPlayerList(params).then((response) => {
        let data = response.data
        this.team = data.team
        this.players = data.players
        this.players.filter(player => {
          if (Number(player.id) === Number(this.playerId)) {
            player.contactNumber = player.mobile
            player.isProfessionalPlayerDesc = player.isProfessionalPlayer === 1 ? '职业球员' : '非职业球员'
            player.isProfessionalPlayer = player.isProfessionalPlayer && player.isProfessionalPlayer.toString()
            player.IDCardNo = player.IDCardNumber
            this.imgObj.avatarImg = ImageFormat.squareImageView(player.avatar, 100)
            this.imgObj.certImg = ImageFormat.squareImageView(player.qualificationFile, 100)
            this.imgObj.insureImg = ImageFormat.squareImageView(player.insureFile, 100)
            player.auditDesc = auditState[player.auditProgress]
            this.player = player
          }
        })
        if (this.player.bmBirthday) {
          this.birthday = Moment.utc(this.player.bmBirthday).toDate()
          this.formatterTime(this.player.bmBirthday)
        }
      })
    },
    formatterTime(date) {
      this.player.bmBirthday = Moment(date).format('YYYY-MM-DD')
    },
    goPermitPage() {
      this.$router.push({
        path: '/player/permit',
        query: {
          name: this.player.trueName,
          avatar: this.player.avatar,
          number: this.player.number,
          team: this.team.name,
          serialNumber: this.player.serialNumber
        }
      })
    }
  }
}
</script>

<style lang="stylus">
  #bm-team-player-detailed
    background-color: white
    width 100%
    .bm-cell
      .note-label
        white-space:pre-line;
        font-size: 12px;
        color: #969799;
        padding: 4px 0;
        border-bottom: 1px solid #f6f6f6;
        margin: 0 15px;
    .van-cell-group
      .van-cell:not(:last-child)::after
        right: 15px
      .van-cell:first-child
        .van-cell__title
          display flex
          align-content center
          align-items: center;
      .van-cell
        font-size:14px;
        font-weight:300;
        color:rgba(74,74,74,1);
        .van-icon::before
          color: #000000
        .desc-label
          position: absolute;
          bottom: 5px;
        .editable
          color: #333;
          font-weight: normal;
    .teamIcon
      width 50px
      height 50px
      background:rgba(230,230,230,1);
      border-radius:50px;
      float: right
      position relative
      img
        width 50px
        height: 50px;
        border-radius: 50%;
        background-color white
      .upload-profile-lod
        position absolute
        left: 0;
        top: 0;
        width 100%
        height: 100%
        background-color white
        .van-loading
          left: 50%
          top: 50%
          transform translate(-50%, -50%)
    .imgIcon
      border-radius 0;
      background-color: #f7f8fa;
      .van-uploader__upload-icon
        color: #dcdee0;
        font-size: 20px;
        position: relative;
        top: 15px;
        right: 15px;
      img
        border-radius 0;
    .foot
      bottom 0
      width 100%
      max-width: 480px
      padding-top 15px
      position fixed
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #32A377;
        line-height:25px;
      .van-button--primary
        background-color #FAFAFA
        font-size:20px;
        font-weight:400;
      .enroll
        height:55px;
        text-align center
        line-height 55px
        font-size:20px;
        color:rgba(255,255,255,1);
        background:rgba(50,163,119,1);
        border-radius:4px;
        width calc(100% - 80px)
        margin: 0 auto
        margin-bottom 30px
    .foot-create
      padding-top: 15px
      bottom 0
      width 100%
      max-width: 480px
      position fixed
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #32A377;
        line-height:25px;
      .van-button--primary
        background-color #FAFAFA
        font-size:20px;
        font-weight:400;
    .popup
      width 100%
      height: 100%
      background-color white
      .van-button
        background-color #32a377
      .back-btn
        background-color #FFFFFF
      .form
        padding: 0 15px;
  .title
    padding: 15px
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin 0
    p
      font-size:14px;
      font-weight:400;
      color:rgba(129,129,129,1);
      line-height:20px;
      margin 0
  .popup-code
    width 100%
    height: 100%;
    background-color: #32A377;
    background-image url('../../../../assets/images/bmb-bg.png')
    background-size 90%
  .code
    background-color white
    padding: 15px;
    width calc(100% - 70px )
    margin auto
    ox-shadow:0px 2px 15px 0px rgba(27,98,70,0.06);
    border-radius:15px;
    text-align center
    position absolute
    top: 45%
    left: 50%
    transform translate(-50%, -50%)
    .title
      font-size:28px;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      color:rgba(50,163,119,1);
    .title+img
      width 120px
      height: 120px
    p
      font-size:16px;
      font-weight:400;
      color:rgba(74,74,74,1);
      line-height:22px;
    .Advertising
      padding-top 10px
      width 100%
      height: 90px
    .off
      display none
      content: ""
      position absolute
      width: 50px
      height: 50px
      background:rgba(255,255,255,1);
      opacity:0.7979;
      bottom -70px
      border-radius 50%
      left 50%
      transform translate(-50%, 0)
      .van-icon
        text-align center
        line-height 50px
        font-size: 30px
        color #000000

  #bm-team-player-detailed .van-cell-group .van-cell .van-icon::before {
    color: #dcdee0;
  }

  #bm-team-player-detailed .van-uploader {
    position: relative;
    display: inline-block;
    height: 100%;
    width: 100%;
  }

  #bm-team-player-detailed .van-button--plain.van-button--info {
    padding: 0 6px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player/player-detailed.vue